export default {
  border: true,
  rounded: '@theme:card.rounded',
  height: '100',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  fontSize: '3',
  fontWeight: 'bold',
  textColor: 'white',
  showDurationTrip: false,
  showLastSeen: true,
  showJourneyType: false,
  showTravelClass: false,
  cursor: 'pointer',
  style: { backgroundColor: 'rgba(0, 0, 0, 0.15)' },
  fareItemBackgroundImage: {
    rounded: '@theme:card.rounded',
    imageHeight: '320px',
  },
  fareBodyItem: {
    paddingWidth: '2',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100',
  },
  fareItemOriginDestination: {
    showOrigin: false,
    showDestinationAirportCode: true,
    showDestinationLabel: true,
    showSeparator: false,
    showLineSeparator: true,
    fontSize: '3',
    textTransform: 'uppercase',
    destinationStyles: {
      fontSize: '5',
    },
    originLabelStyles: {
      paddingRight: '1',
      fontWeight: 'light',
    },
    destinationLabelStyles: {
      paddingRight: '1',
      fontWeight: 'light',
    },
  },
  fareItemPrice: {
    pricePromoLabelKey: 'cmp-fare-price-promo-short',
    showCurrencyCode: true,
    showCurrencySymbol: false,
    showPricePromo: true,
    showPriceDisclaimer: false,
    paddingTop: '2',
    paddingBottom: '1',
    textAlign: 'center',
    style: { lineHeight: '1' },
    pricePromoStyles: {
      fontWeight: 'light',
      textTransform: 'uppercase',
    },
    currencyStyles: {
      fontSize: '5',
      marginHeight: '2px',
    },
  },
  fareItemLastSeen: {
    dateStyles: {
      fontWeight: 'light',
    },
  },
  showDepartureInfo: false,
  fareItemDepartureInfo: {
    showDepartureText: true,
    showDepartureDate: true,
    departureText: 'cmp-label--departure-date-colon',
    fontWeight: 'light',
    departureTextLabelStyle: {
      fontWeight: 'bold',
    },
  },
  separatorDatesProps: {
    content: 'minus',
  },
  showReturnInfo: false,
  fareItemReturnInfo: {
    showReturnText: true,
    showReturnDate: true,
    returnText: 'cmp-label--return-date-colon',
    fontWeight: 'light',
    returnTextLabelStyles: {
      fontWeight: 'bold',
    },
  },
};
